import React, { useState } from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import BundleItemCard from '../gifts/bundleItemCard'
import { Gift } from '../../../models/Gift'
import { deleteGiftBundle, updateGift } from '../../../services/giftService'
import { toast } from 'react-toastify'
import constants from '../../../config/constants'
import ConfirmationModal from '../../common/modals/confirm'
import GiftBundleModal from './giftBundleModal'
import { ButtonName } from '../../../config/enums'
import { friendlyMessageFor } from '../../../utility/errorHelper'

type Props = {
  name: string
  gifts: Gift[]
  giftBundleId: string
}

const GiftsBundleItem = ({ name, gifts, giftBundleId }: Props) => {
  const [showRemoveModal, setShowRemoveModal] = useState(false)
  const [showEditGiftBundleModal, setShowEditGiftBundleModal] = useState(false)
  const [showDeleteBundleModal, setShowDeleteBundleModal] = useState(false)
  const [isDeleteBundleModalLoading, setIsDeleteBundleModalLoading] = useState(
    false
  )

  return (
    <>
      <GiftBundleModal
        show={showEditGiftBundleModal!}
        type={ButtonName.edit}
        handleClose={() => {
          setShowEditGiftBundleModal(false)
        }}
        giftBundleId={giftBundleId}
        name={name}
      />
      <ConfirmationModal
        show={showDeleteBundleModal}
        body={`Remove ${name}?`}
        isLoading={isDeleteBundleModalLoading}
        onCancelClick={() => setShowDeleteBundleModal(false)}
        onConfirmClick={() => {
          setIsDeleteBundleModalLoading(true)
          deleteGiftBundle(giftBundleId).then(success => {
            if (success) {
              window.location.reload()
            } else {
              toast.error(friendlyMessageFor(''), {
                autoClose: false
              })
            }
          })
        }}
      />
      <Row className="mx-auto">
        <Col xs={12}>
          <Row data-testid="box-bundle">
            <Col xs={9}>
              <h3>{name}</h3>
            </Col>

            <Col className="text-right">
              <Button
                variant="danger"
                className="mr-3"
                onClick={() => setShowDeleteBundleModal(true)}
              >
                Remove
              </Button>

              <Button
                variant="primary"
                onClick={() => setShowEditGiftBundleModal(true)}
              >
                Edit
              </Button>
            </Col>
          </Row>

          <Row className="box mt-3 mb-5">
            {gifts.length >= 1 ? (
              gifts.map((gift: Gift) => {
                return (
                  <Col xs={4} className="pb-5" key={gift.id}>
                    <ConfirmationModal
                      show={showRemoveModal}
                      body={`Remove ${gift.name} from bundle?`}
                      onCancelClick={() => setShowRemoveModal(false)}
                      onConfirmClick={() => {
                        updateGift(
                          gift.id,
                          undefined,
                          undefined,
                          [''],
                          undefined
                        ).then(result => {
                          if (result) {
                            toast.success(
                              constants.alertMessage.updateGiftSuccessful,
                              {
                                autoClose: 3000
                              }
                            )
                            window.location.reload()
                          } else {
                            toast.error(constants.alertError.generic)
                            setShowRemoveModal(false)
                          }
                        })
                      }}
                    />
                    <Row>
                      <BundleItemCard
                        imageSrc={gift.imageUrl}
                        itemActive={gift.isActive}
                        itemTitle={gift.name}
                        itemButtonUrl={`/vendor/editgift/${gift.id}`}
                      />
                    </Row>
                    <Row>
                      <Col xs={12} className="text-center">
                        <Button
                          variant="danger"
                          className="text-center"
                          onClick={() => setShowRemoveModal(true)}
                        >
                          Remove
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                )
              })
            ) : (
              <Col> No gifts</Col>
            )}
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default GiftsBundleItem
